// extracted by mini-css-extract-plugin
module.exports = {"modalityListStyle":"W9qDgenoFEZlKbXAUWRGH"};